import wcShared from '@web-components/shared';

import { resetStatusStore, StatusStore } from './store/status.store';
import { CustomStatus, UserPresence, UserStatus } from './type/status.type';

export default function () {
  window.addEventListener('wcUsersStatusFlush', resetStatusStore);

  window.addEventListener(
    'wcUserStatusUpdate',
    (
      e: CustomEvent<{
        presence?: { status: UserPresence; dnd_end_time?: number };
        customStatus?: CustomStatus;
        id: number;
      }>,
    ) => {
      const { id, customStatus, presence } = e.detail;
      if (!id) return;
      StatusStore.userStatuses = {
        ...StatusStore.userStatuses,
        [id]: {
          ...StatusStore.userStatuses[id],
          customStatus:
            customStatus === undefined
              ? { ...StatusStore.userStatuses[id]?.customStatus }
              : customStatus,
          presence: {
            status: presence?.status,
            dnd_end_time: StatusStore.userStatuses[id]?.presence?.dnd_end_time,
          },
        },
      };
    },
  );

  window.addEventListener(
    'wcUsersStatusCreate',
    (
      e: CustomEvent<{
        url: string;
        statuses: {
          [props: string]: {
            presence?: UserPresence;
            customStatus?: CustomStatus;
            id: number;
            uuid: string;
          };
        };
      }>,
    ) => {
      const userStatuses = { ...StatusStore.userStatuses };
      Object.values(e.detail.statuses).forEach((item) => {
        const { id, ...rest } = item;
        userStatuses[id] = { ...userStatuses[id], ...rest } as UserStatus;
      });
      wcShared.store.kChatURL = e.detail.url;
      wcShared.store.kChatServerName = new URL(wcShared.store.kChatURL).host.split('.')[0];
      StatusStore.userStatuses = userStatuses;
    },
  );
  if (window['CURRENT_PROJECT'] === 'kchat') {
    wcShared.store.kChatURL = window.location.origin;
  }

  wcShared.store.ksuiteBridge?.sendMessage({ type: 'module-ready', module: 'status' });
  window.dispatchEvent(new CustomEvent('module-ready', { detail: 'status' }));
}
